import Component from '../Component';

/**
 * Generates a route resolver for a given component.
 *
 * In addition to regular route resolver functionality:
 * - It provide the current route name as an attr
 * - It sets a key on the component so a rerender will be triggered on route change.
 */
export default class DefaultResolver {
  constructor(component, routeName) {
    this.component = component;
    this.routeName = routeName;
  }

  /**
   * When a route change results in a changed key, a full page
   * rerender occurs. This method can be overridden in subclasses
   * to prevent rerenders on some route changes.
   */
  makeKey() {
    return this.routeName + JSON.stringify(m.route.param());
  }
  makeAttrs(vnode) {
    return {
      ...vnode.attrs,
      routeName: this.routeName
    };
  }
  async onmatch(args, requestedPath, route) {
    if (this.component.prototype instanceof Component) {
      return this.component;
    }
    return (await this.component()).default;
  }
  render(vnode) {
    return [{
      ...vnode,
      attrs: this.makeAttrs(vnode),
      key: this.makeKey()
    }];
  }
}
flarum.reg.add('core', 'common/resolvers/DefaultResolver', DefaultResolver);